import { render, staticRenderFns } from "./filtro-positivo.vue?vue&type=template&id=7dc5bd28&"
import script from "./filtro-positivo.vue?vue&type=script&lang=js&"
export * from "./filtro-positivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc5bd28')) {
      api.createRecord('7dc5bd28', component.options)
    } else {
      api.reload('7dc5bd28', component.options)
    }
    module.hot.accept("./filtro-positivo.vue?vue&type=template&id=7dc5bd28&", function () {
      api.rerender('7dc5bd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/filtro-positivo.vue"
export default component.exports